export const CURRENCY_SYMBOLS = { gbp: '£', usd: '$', eur: '€' };

const EUROZONE = new Set([
  'AT', 'BE', 'HR', 'CY', 'EE', 'FI', 'FR', 'DE', 'GR', 'IE', 'IT', 'LV', 'LT',
  'LU', 'MT', 'NL', 'PT', 'SK', 'SI', 'ES', 'AD', 'MC', 'SM', 'VA', 'ME', 'XK'
]);

// Best-effort local currency detection: US -> USD, eurozone -> EUR, else GBP.
// Users can override with the on-screen toggle; the backend validates & locks.
export const detectCurrency = () => {
  try {
    const region = new Intl.Locale(navigator.language || 'en-GB').region;
    if (region === 'US') return 'usd';
    if (EUROZONE.has(region)) return 'eur';
  } catch (e) { /* ignore */ }
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || '';
    if (/^America\/(New_York|Chicago|Denver|Los_Angeles|Phoenix|Anchorage|Detroit|Indiana|Kentucky|Boise|Juneau|Sitka|Menominee|Nome)/.test(tz)) return 'usd';
    if (tz === 'Pacific/Honolulu') return 'usd';
    if (/^Europe\/(Vienna|Brussels|Zagreb|Nicosia|Tallinn|Helsinki|Paris|Berlin|Athens|Dublin|Rome|Riga|Vilnius|Luxembourg|Malta|Amsterdam|Lisbon|Bratislava|Ljubljana|Madrid|Andorra|Monaco|San_Marino|Vatican|Podgorica)/.test(tz)) return 'eur';
  } catch (e) { /* ignore */ }
  return 'gbp';
};
